
import Home from "pages/home";

export default function HomePage() {
  return <Home />;
}
